// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

import React from 'react';
import './GameIcon.css';

/**
 * GameIcon Component
 * 
 * Displays SVG icons for aliens, weapons, and status indicators.
 * Supports sizing, colors, and glow effects matching the cyberpunk aesthetic.
 * 
 * @param {string} type - Icon category: 'alien', 'weapon', 'status'
 * @param {string} name - Icon name (e.g., 'vogons', 'laser', 'shields')
 * @param {number} size - Icon size in pixels (default: 32)
 * @param {string} color - Override color (optional)
 * @param {boolean} glow - Enable glow effect (default: false)
 * @param {string} className - Additional CSS classes
 * @param {object} style - Inline styles
 */
const GameIcon = ({ 
  type, 
  name, 
  size = 32, 
  color, 
  glow = false, 
  className = '', 
  style = {},
  ...props 
}) => {
  const iconPath = `/icons/${type}s/${name}.svg`;
  
  const iconStyle = {
    width: `${size}px`,
    height: `${size}px`,
    filter: glow ? 'drop-shadow(0 0 8px currentColor)' : 'none',
    color: color || 'inherit',
    ...style
  };
  
  return (
    <img 
      src={iconPath}
      alt={`${name} ${type}`}
      className={`game-icon game-icon-${type} ${className}`}
      style={iconStyle}
      {...props}
    />
  );
};

export default GameIcon;
